export const typography = {
  fontFamilyIcons: "Material Icons",

  // FONT SIZE
  fontSizeButton: "1.4rem",
  fontSizeButtonSmall: "1.2rem",

  fontSizeLabel: "1.4rem",
  fontSizeLabelBig: "1.6rem",
  fontSizeLabelExtraBig: "2.1rem",
  fontSizeLabelMedium: "1.3rem",
  fontSizeLabelSmall: "1.2rem",

  fontSizeText: "1.6rem",
  fontSizeTextExtraSmall: "1.2rem",
  fontSizeTextMedium: "1.4rem",
  fontSizeTextSmall: "1.3rem",

  fontSizeTitle: "2.0rem",
  fontSizeTitleBig: "2.8rem",
  fontSizeTitleExtraBig: "4.0rem",

  fontWeight: 400,
  fontWeightBold: 700,

  // FONT WEIGHT
  fontWeightLight: 300,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,

  // FONT FAMILY
  textFontFamily: `"Inter", "sans-serif"`,
  titleFontFamily: `"Inter", "sans-serif"`,
}
